import { Autocomplete } from "@/components/atoms";
import { useFilterJobs, useUserContext } from "@/providers/contexts";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useJobPostFilterOptions } from "@/hooks";

// Only available to premium users

export const JobRoleFilter = () => {
  const { disabledBasicContent, disabledProContent, isAuthenticated } =
    useUserContext();
  const { filters: jobPostFilters, loading: jobPostFiltersLoading } =
    useJobPostFilterOptions();
  const { filters, dispatch, loading } = useFilterJobs();

  const jobRoles = jobPostFilters?.jobRoles ?? [];
  const { selectedJobRoles } = filters;
  const disabledContent =
    disabledBasicContent || disabledProContent || !isAuthenticated;

  const options = jobRoles.map(jobRole => ({
    key: jobRole.id,
    value: jobRole.role_name,
  }));

  const selectedOptions = selectedJobRoles.map(selected => {
    const jobRole = jobRoles.find(jr => jr.id === selected.id);

    return {
      key: jobRole?.id ?? "",
      value: jobRole?.role_name ?? "",
    };
  });

  return (
    <Autocomplete
      componentName={"job-role-filter"}
      disabled={disabledContent}
      multiple
      inputLabel="Job Roles"
      options={options}
      value={selectedOptions}
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = jobRoles.filter(jobRole =>
          selectedValues.some(el => el.value === jobRole.role_name),
        );

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedJobRoles: selected },
        });
      }}
      loading={loading || jobPostFiltersLoading}
      tooltipMessage={
        disabledContent
          ? "Upgrade your account to access this feature"
          : undefined
      }
      readMoreLink="/memberships"
    />
  );
};
